export const VOICE_ENDED_REASON_HANGUP = 'hangup';
export const VOICE_ENDED_REASON_AGENT_DECLINED = 'agent-declined-call';
export const VOICE_ENDED_REASON_AGENT_CANCELLED = 'agent-cancelled-call';

/**
 * @param {{ wasAnswered?: boolean, isOutboundRinging?: boolean }} input
 * @returns {typeof VOICE_ENDED_REASON_HANGUP | typeof VOICE_ENDED_REASON_AGENT_DECLINED | typeof VOICE_ENDED_REASON_AGENT_CANCELLED}
 */
export function resolveVoiceHangupEndedReason(input = {}) {
  if (input.wasAnswered) {
    return VOICE_ENDED_REASON_HANGUP;
  }
  if (input.isOutboundRinging) {
    return VOICE_ENDED_REASON_AGENT_CANCELLED;
  }
  return VOICE_ENDED_REASON_AGENT_DECLINED;
}
